const rules = new Intl.PluralRules("lt");

export const pluralize = (translation: string, count: number): string => `${translation}_${rules.select(count)}`;
